import * as React from 'react';

import {WhatsNewBanner} from 'shells/whats-new/whats-new-banner';

import {useOpenableModal} from '../openable-modals';

import type {LearnMoreConfig} from './feedback-surveys';

export type BannerProps = {
    message: string;
    feedbackLabel?: string;
    onOpenSurvey: () => void;
    onHidden: () => void;
    animate: boolean;
    lessPadding: boolean;
};

type Props = BannerProps & {
    learnMoreConfig: LearnMoreConfig;
};

/*
 * Wraps the WhatsNewBanner with our openable modal logic
 */
export function LearnMoreWrapper(props: Props) {
    const {learnMoreConfig, ...bannerProps} = props;
    const {onOpen: onOpenLearnMore} = useOpenableModal(learnMoreConfig.openableModalId);

    const handleLearnMoreClick = React.useCallback(() => {
        if (onOpenLearnMore) {
            onOpenLearnMore();
        }
    }, [onOpenLearnMore]);

    return (
        <WhatsNewBanner
            {...bannerProps}
            primaryLabel={learnMoreConfig.label || 'Learn more'}
            onPrimaryClick={handleLearnMoreClick}
        />
    );
}
